<div class="header">
    <div class="top">
        <a routerLink="/home/dining/general">
            <h3>Comedor /</h3>
            <div class="breadcrumb">
                <mat-icon svgIcon="arrow back"></mat-icon>
                <h2> Editar fechas</h2>
            </div>
        </a>
    </div>
</div>
<div class="content">
    <div class="selector">
        <p>SELECCIONE UNA ACCIÓN PARA EDITAR EL CALENDARIO</p>
        <mat-form-field appearance="outline">
            <mat-label>Seleccione acción</mat-label>
            <mat-select [(value)]="selected" (selectionChange)="onModeChange($event.value)">
                <mat-option value="select">Seleccionar</mat-option>
                <mat-option value="block">Bloquear fechas</mat-option>
                <mat-option value="unblock">Desbloquear fechas</mat-option>
                <mat-option value="add">Añadir eventos corporativos</mat-option>
                <mat-option value="delete">Editar o eliminar eventos corporativos</mat-option>
            </mat-select>
        </mat-form-field>
        @switch (selected) {
        @case ('block') {
        <mat-divider></mat-divider>
        @if (dataLoaded) {
        <app-calendar [type]="'block'" [events]="eventDays" [blocked]="blockedDays"
            (hasSelection)="onDatesSelected($event)"></app-calendar>
        } @else {
        <div class="loading-calendar">
            <p>Cargando calendario...</p>
        </div>
        }
        <mat-divider></mat-divider>
        @for(evento of eventos; track evento.date){
        <div class="dates">
            <h3>{{evento.date}}</h3>
            <mat-radio-group [(ngModel)]="evento.blockType" aria-label="Select an option" style="margin-left: 10px;">
                <mat-radio-button value="HOLIDAY">Festivo</mat-radio-button>
                <mat-radio-button value="NO_SERVICE">Sin servicio</mat-radio-button>
            </mat-radio-group>
            <mat-form-field appearance="outline">
                <mat-label>Razón del bloqueo</mat-label>
                <input matInput [(ngModel)]="evento.reason" required>
                @if (!evento.reason) {
                <mat-error>La razón es obligatoria</mat-error>
                }
            </mat-form-field>
            <mat-divider></mat-divider>
        </div>
        }
        @if (eventos.length > 0 && !areAllEventosValid()) {
        <div class="validation-error">
            <p>Todas las fechas deben tener tipo de bloqueo y razón especificados.</p>
        </div>
        }
        <button mat-flat-button id="action" [disabled]="!hasSelectedDates || !areAllEventosValid()"
            (click)="block()">Bloquear</button>
        <button mat-flat-button id="cancel" (click)="resetCalendarSelection()">Cancelar</button>
        }
        @case ('unblock') {
        <mat-divider></mat-divider>
        @if (dataLoaded) {
        <app-calendar [type]="'unblock'" [events]="eventDays" [blocked]="blockedDays"
            (hasSelection)="onDatesSelected($event)"></app-calendar>
        } @else {
        <div class="loading-calendar">
            <p>Cargando calendario...</p>
        </div>
        }

        @for(evento of eventos; track evento.date; let last = $last; let first = $first){
        <div class="dates">
            @if (first) {
            <mat-divider></mat-divider>
            }
            <h3>{{evento.date}}</h3>
            @if (!last) {
            <mat-divider></mat-divider>
            }
        </div>
        }
        <mat-divider></mat-divider>
        <button mat-flat-button id="action" [disabled]="!hasSelectedDates" (click)="unblock()">Desbloquear</button>
        <button mat-flat-button id="cancel" (click)="resetCalendarSelection()">Cancelar</button>
        }
        @case ('add') {
        <mat-divider></mat-divider>
        @if (dataLoaded) {
        <app-calendar [type]="'add'" [events]="eventDays" [blocked]="blockedDays"
            (hasSelection)="onDatesSelected($event)"></app-calendar>
        } @else {
        <div class="loading-calendar">
            <p>Cargando calendario...</p>
        </div>
        }
        <mat-divider></mat-divider>
        @for(evento of eventos; track evento.date){
        <div class="dates">
            <h3>{{evento.date}}</h3>
            <mat-form-field appearance="outline">
                <mat-label>Nombre del evento</mat-label>
                <input matInput [(ngModel)]="evento.name" required>
                @if (!evento.name) {
                <mat-error>El nombre del evento es obligatorio</mat-error>
                }
            </mat-form-field>
            <mat-divider></mat-divider>
        </div>
        }
        @if (eventos.length > 0 && !areAllEventNamesValid()) {
        <div class="validation-error">
            <p>Todos los eventos deben tener un nombre asignado.</p>
        </div>
        }
        <button mat-flat-button id="action" [disabled]="!hasSelectedDates || !areAllEventNamesValid()"
            (click)="addEvent()">Añadir +</button>
        <button mat-flat-button id="cancel" (click)="resetCalendarSelection()">Cancelar</button>
        }
        @case ('delete') {
        <mat-divider></mat-divider>
        @if (dataLoaded) {
        <app-calendar [type]="'delete'" [events]="eventDays" [blocked]="blockedDays"
            (hasSelection)="onDatesSelected($event)" (monthChanged)="onMonthChanged($event)"></app-calendar>
        } @else {
        <div class="loading-calendar">
            <p>Cargando calendario...</p>
        </div>
        }
        <mat-divider></mat-divider>
        @if (eventos.length === 0) {
        <div class="no-events-message">
            <p>No hay eventos en el mes actual.</p>
        </div>
        } @else {
        @for(evento of eventos; track evento.date){
        <div class="dates">
            <h3>{{evento.date}}</h3>
            <mat-form-field appearance="outline">
                <mat-label>Nombre del evento</mat-label>
                <input matInput [(ngModel)]="evento.name" required>
                @if (!evento.name) {
                <mat-error>El nombre del evento es obligatorio</mat-error>
                }
            </mat-form-field>
            <button mat-icon-button (click)="deleteEvent(evento)">
                <mat-icon svgIcon="delete"></mat-icon>
            </button>
            <mat-divider></mat-divider>
        </div>
        }
        <button mat-flat-button id="action" [disabled]="!hasSelectedDates || !areAllEventNamesValid()"
            (click)="saveEventChanges()">Guardar cambios</button>
        <button mat-flat-button id="cancel" (click)="resetCalendarSelection()">Cancelar</button>
        }
        }
        }
    </div>
    <div class="right">
        <h4>Información</h4>
        <p>Tiempo máximo para hacer su reserva: hasta el día anterior a las 15h laborable (no en domingo o festivo).</p>
        <mat-divider></mat-divider>
        <div class="line">
            <div class="available"></div>
            <p>Días disponibles para reservar.</p>
        </div>
        <mat-divider></mat-divider>
        <div class="line">
            <div class="selected"></div>
            <p>Día seleccionado.</p>
        </div>
        <mat-divider></mat-divider>
        <div class="line">
            <div class="event"></div>
            <p>Evento corporativo: Serveto invita a todos los trabajadores al comedor de manera gratuita.</p>
        </div>
        <mat-divider></mat-divider>
        <div class="line">
            <div class="blocked"></div>
            <p>Día bloqueado, no puede hacer reservas.</p>
        </div>
        <mat-divider></mat-divider>
        <p class="cancel-reservation">Anular reserva</p>
        <p>Tiempo máximo para anular su reserva: hasta el día anterior a las 15h laborable (no en domingo o festivo).
        </p>
    </div>
</div>